/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/UnfoldLess';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const UnfoldLessIcon = withMuiAdapter(Base, 'UnfoldLess');
